var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.987 4a2 2 0 012 2v6.071a1 1 0 11-2 0V7.416L7.792 17.698h4.28a1 1 0 110 2H6a2 2 0 01-2-2v-6.07a1 1 0 112 0v5.037L16.575 6h-4.659a1 1 0 110-2h6.071z",
    fill: "#fff"
  })));
}
export default SvgExpand;